<template>
  <div class="odmik-vsebine-nastavtive-telefonija mobile-odmik">
    <div v-loading="nalaganjeOdzivnika">
      <div v-if="podatkiOdzivnika.statusVoiceMail === false">
        <div class="postavitev-icone">
          <img src="/../../static/img/Nastavitve/Telefonija/TelefonskiOdzivnik.svg">
        </div>
        <div class="postavitev-besedila">
          <div>
            <p class="navadno-besedilo">
              Na vašem uporabniškem računu še nimate ustvarjenega telefonskega odzivnika.
            </p>
          </div>
          <div style="padding-top: 20px">
            <p class="navadno-besedilo">
              Interaktivni odzivnik naročniku omogoča, da lahko preko posnetega pozdravnega sporočila posreduje dohodni
              klic na želeno službo, oziroma (v primeru <br/> dvonivojskega načina) tudi do končnega uporabnika brez
              posredovanja tretje osebe. Postavitev in delovanje v celoti zagotovi T-2.
            </p>
          </div>
          <div v-if="podatkiOdzivnika.statusVoiceMail === false" style="padding-top: 30px">
            <div class="navadno-besedilo">
              <div>
                <el-button type="primary" @click="UstvariOdzviznik" class="gumb-potrdi dodan-padding">
                  USTVARI ODZIVNIK
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="podatkiOdzivnika.statusVoiceMail === true" style="clear: both">
        <div>
          <p class="navadno-besedilo">
            Telefonski odzivnik je storitev, ki omogoča sprejem glasovnih sporočil klicateljev ob nedosegljivost vaše
            telefonske številke. Preusmeritev na telefonki odzivnik aktivirate v zavihku Preusmeritve.
          </p>
          <p class="navadno-besedilo">
            Več informacij o uporabi telefonskega odzivnika boste našli
            <a :href="povezavaUrlT2Stran" class="primarna-barva">tukaj</a>.
          </p>
        </div>
        <div style="padding-top: 30px">
          <el-form label-width="160px" :label-position="formaOrientacija">
            <el-form-item label="Način pozdrava">
              <el-select v-model="izbranPozdrav" placeholder="Izberite način pozdrava"
                         class="velikost-inputa">
                <el-option
                  v-for="(poz, key) in telOdzivnikPozdravi"
                  :label="poz"
                  :value="poz"
                  :key="key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="obvestilo-vklop" label="E-poštno obvestilo">
              <el-checkbox v-model="podatkiOdzivnika.voiceMailData.emailNotification"/>
            </el-form-item>
            <el-form-item label="">
              <span slot="label">
                Elektronska pošta
                <el-tooltip class="item mobile-info" effect="dark" style="color: #EF7D00"
                            :content="epostaInfo"
                            placement="right">
                  <el-icon class="el-icon-info">
                  </el-icon>
                </el-tooltip>
              </span>
              <el-input placeholder="Elektronska pošta" v-model="podatkiOdzivnika.voiceMailData.email"
                        class="velikost-inputa"/>
              <el-tooltip class="item desktop-info" effect="dark" style="color: #EF7D00"
                          :content="epostaInfo"
                          placement="right">
                <el-icon class="el-icon-info">
                </el-icon>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="Uporabniško ime">
              <el-input placeholder="Vnesite uporabniško ime" :disabled="true"
                        v-model="podatkiOdzivnika.voiceMailData.login"
                        class="velikost-inputa">
              </el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                Geslo
                <el-tooltip class="item mobile-item mobile-info" effect="dark" style="color: #EF7D00"
                            content="Uporabite lahko 4-mestno številko."
                            placement="right">
                  <el-icon class="el-icon-info"></el-icon>
                </el-tooltip>
              </span>
              <el-input placeholder="Vnesite geslo" v-model="podatkiOdzivnika.voiceMailData.password"
                        :maxlength="4" class="velikost-inputa" @keyup.native="PreverjanjeStevil()">
              </el-input>
              <el-tooltip class="item mobile-item desktop-info" effect="dark" style="color: #EF7D00"
                          content="Uporabite lahko 4-mestno številko."
                          placement="right">
                <el-icon class="el-icon-info"></el-icon>
              </el-tooltip>
            </el-form-item>
          </el-form>
          <div style="clear: both; padding-top: 30px">
            <div style="padding-bottom: 20px">
              <a class="stil-gumb-preklici" @click="IzbrisiOdzviznik">
                <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                     class="img-postavitev">
                <span>
                  IZBRIŠI ODZIVNIK
                </span>
              </a>
            </div>
            <div style="padding-top: 20px">
              <el-button @click="UrejanjeOdzivnika" class="gumb-potrdi">
                SHRANI SPREMEMBE
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {povezave} from '../../../../../../assets/js/Povezave/povezave'
  import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
  import {
    Tabs, TabPane, Select, Option, Button, Checkbox, Input, Tooltip, Collapse, CollapseItem,
    MessageBox
  } from 'element-ui'
  import ClientAgent from '../../../../../../assets/js/clientAgent.js'

  export default {
    name: 'TelefonskiOdzivnik',
    mixins: [PrikazVsebine],
    data () {
      return {
        podatkiOdzivnika: {},
        izbranPozdrav: '',
        telOdzivnikPozdravi: {},
        formaOrientacija: 'left',
        mejnaSirina: 1200,
        telOdzivnik: [],
        povezavaUrlT2Stran: '',
        nalaganjeOdzivnika: false,
        epostaInfo: 'Vpišite e-naslov in ob vsakem sporočilu na odzivniku boste prejeli obvestilo, skupaj s posnetkom.'
      }
    },
    props: {
      izbranPrikljucek: String,
      izbranaTelefonska: String
    },
    components: {
      [Tooltip.name]: Tooltip,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Select.name]: Select,
      [Option.name]: Option,
      [Input.name]: Input,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem
    },
    watch: {
      izbranaTelefonska: function () {
        if (this.izbranPrikljucek !== null) {
          this.GetOdzivnik()
        }
      },
      orientacija: function (val) {
        this.formaOrientacija = val
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.povezavaUrlT2Stran = povezave.BASE_URL_T2_STRAN
      this.GetOdzivnik()
      this.$nextTick(function () {
        window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
        window.dispatchEvent(new Event('resize'))
      })
    },
    methods: {
      GetOdzivnik () {
        if (this.izbranPrikljucek !== '') {
          this.nalaganjeOdzivnika = true
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('stevilka=' + this.izbranaTelefonska)
          this.clientAgent.postWsRequest(this,
            'prikljucek/telefonija/getOdzivnik?',
            param,
            null,
            'PridobljeniPodatkiOdzivnika',
            'ErrPridobljeniPodatkiOdzivnika')
        }
      },
      PridobljeniPodatkiOdzivnika (podatki) {
        this.telOdzivnik = []
        this.telOdzivnikPozdravi = {}
        this.podatkiOdzivnika = {}
        this.telOdzivnik = podatki
        this.$emit('jeStatusOdzivnika', this.telOdzivnik.statusVoiceMail)
        this.telOdzivnikPozdravi = podatki.greetingModes
        this.podatkiOdzivnika = podatki
        this.izbranPozdrav = podatki.voiceMailData.greetingModeId
        for (let greet in this.telOdzivnikPozdravi) {
          if (greet === this.izbranPozdrav) {
            this.izbranPozdrav = this.telOdzivnikPozdravi[greet]
            break
          }
        }
        this.nalaganjeOdzivnika = false
      },
      ErrPridobljeniPodatkiOdzivnika (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
      },
      PreverjanjeStevil () {
        Vue.set(this.podatkiOdzivnika.voiceMailData, 'password',
          this.podatkiOdzivnika.voiceMailData.password.replace(/[^\d]/g, ''))
      },
      UstvariOdzviznik () {
        if (this.izbranPrikljucek !== '') {
          this.nalaganjeOdzivnika = true
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('stevilka=' + this.izbranaTelefonska)
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/telefonija/ustvariOdzivnik?',
            param,
            null,
            'SetUstvarjenOdzivnik',
            'ErrUstvarjenOdzivnik')
        }
      },
      SetUstvarjenOdzivnik () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno ustvarjen odzivnik.'
        this.ShowSuccessMessage(paramObvestilo)
        this.GetOdzivnik()
      },
      ErrUstvarjenOdzivnik (podatki) {
        this.ShowWarningMessage(podatki)
        this.nalaganjeOdzivnika = false
      },
      IzbrisiOdzviznik () {
        if (this.izbranPrikljucek !== '') {
          MessageBox.confirm(
            'Ali ste prepričani, da želite odstraniti telefonski odzivnik.', {
              confirmButtonText: 'Da',
              cancelButtonText: 'Prekliči',
              confirmButtonClass: 'gumb-potrdi',
              cancelButtonClass: 'gumb-preklici',
              customClass: 'opozorilo-dialog'
            }).then(() => {
            this.nalaganjeOdzivnika = true
            let param = ['idPrikljucek=' + this.izbranPrikljucek]
            param.push('stevilka=' + this.izbranaTelefonska)
            this.clientAgent.postWsRequest(
              this,
              'prikljucek/telefonija/izbrisiOdzivnik?',
              param,
              null,
              'SetIzbrisiOdzviznik',
              'ErrIzbrisiOdzviznik')
          }).catch((err) => {
            err = null
          })
        }
      },
      SetIzbrisiOdzviznik () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno izbrisan odzivnik.'
        this.ShowSuccessMessage(paramObvestilo)
        this.GetOdzivnik()
      },
      ErrIzbrisiOdzviznik (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeOdzivnika = false
      },
      UrejanjeOdzivnika () {
        this.nalaganjeOdzivnika = true
        let zacasenTipPozdrava = ''
        for (let greet in this.telOdzivnikPozdravi) {
          if (this.telOdzivnikPozdravi[greet] === this.izbranPozdrav) {
            zacasenTipPozdrava = greet
            break
          }
        }
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        param.push('greetingMode=' + zacasenTipPozdrava)
        param.push('password=' + this.podatkiOdzivnika.voiceMailData.password)
        if (this.podatkiOdzivnika.voiceMailData.emailNotification === true) {
          param.push('emailNotifications=' + this.podatkiOdzivnika.voiceMailData.emailNotification)
          param.push('email=' + this.podatkiOdzivnika.voiceMailData.email)
        } else {
          param.push('emailNotifications=' + this.podatkiOdzivnika.voiceMailData.emailNotification)
          param.push('email=')
        }
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/posodobiOdzivnik?',
          param,
          null,
          'SetUrejanjeOdzivnika',
          'ErrUrejanjeOdzivnika')
      },
      SetUrejanjeOdzivnika () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Posodobljen telefonski odzivnik.'
        this.ShowSuccessMessage(paramObvestilo)
        this.nalaganjeOdzivnika = false
        this.GetOdzivnik()
      },
      ErrUrejanjeOdzivnika (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowSuccessMessage(paramObvestilo)
        this.nalaganjeOdzivnika = false
      }
    }
  }
</script>
<style scoped
       src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveStacionarnaTelefonija/TelefonskiOdzivnik.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveStacionarnaTelefonija/TelefonskiOdzivnik.vue